import { Logo } from "@components/shared/nav/Logo";
import { useTranslation } from "react-i18next";

import styles from "./Footer.module.scss";

type FooterLink = { label: string; href: string };

export function Footer() {
  const { t } = useTranslation();
  const navLinks = t("footer.navLinks", { returnObjects: true }) as FooterLink[];
  const legalLinks = t("footer.legalLinks", { returnObjects: true }) as FooterLink[];

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <div className={styles.footGrid}>
          <div className={styles.footBrand}>
            <a href="#top" className={styles.brandLink}>
              <Logo color="var(--accent)" />
              {t("common.brand")}
            </a>
            <p className={styles.brandDesc}>{t("footer.description")}</p>
          </div>

          <div className={styles.footCol}>
            <div className={styles.footH}>{t("footer.mainPages")}</div>
            <ul>
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.footCol}>
            <div className={styles.footH}>{t("footer.legal")}</div>
            <ul>
              {legalLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.footCol}>
            <div className={styles.footH}>{t("footer.contact")}</div>
            <ul>
              <li>
                <a href={`mailto:${t("footer.email")}`}>{t("footer.email")}</a>
              </li>
              <li>
                <a href={`tel:${t("footer.phone").replace(/\s+/g, "")}`}>{t("footer.phone")}</a>
              </li>
              <li>
                <address className={styles.address}>
                  {t("footer.addressLine1")}
                  <br />
                  {t("footer.addressLine2")}
                </address>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.footBot}>
          <span>{t("footer.copyright")}</span>
        </div>
      </div>
    </footer>
  );
}
